import { request, success, failure, EXPENSE_REQUEST } from './utilities';
import {
    getAllExpenses,
    getFilteredExpenses,
    removeExpense,
    addNewExpense,
    getExpenseTypes,
    addNewExpenseType,
    deleteExpenseType,
    getSubExpenseTypes,
    addSubExpenseType,
    deleteSubExpenseType,
    addNewExpenseList
} from '../api';

export function getExpensesList() {
    return (dispatch) => {
        dispatch(request(EXPENSE_REQUEST.GET_EXPENSE_REQUEST));
        getAllExpenses().then(
            response => {
                if (response.data.message === "Success") {
                    dispatch(success(EXPENSE_REQUEST.GET_EXPENSE_SUCCESS, response.data.data))
                }
                else {
                    dispatch(failure(EXPENSE_REQUEST.GET_EXPENSE_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(EXPENSE_REQUEST.GET_EXPENSE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
            }
        )
    };
}

export function getFilteredExpenseList(expenseData) {
    return (dispatch) => {
        dispatch(request(EXPENSE_REQUEST.GET_EXPENSE_REQUEST));
        getFilteredExpenses(expenseData).then((res) => {
            if (res.data.message === "Success") {
                dispatch(success(EXPENSE_REQUEST.GET_EXPENSE_SUCCESS, res.data.data))
            } else {
                dispatch(failure(EXPENSE_REQUEST.GET_EXPENSE_FAILURE, res.data.message))
            }
        }, (error) => {
            dispatch(failure(EXPENSE_REQUEST.GET_EXPENSE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        })
    }
}

export function deleteExpense(expenseId) {
    return (dispatch) => {
        dispatch(request(EXPENSE_REQUEST.DELETE_EXPENSE_REQUEST));
        removeExpense(expenseId).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(EXPENSE_REQUEST.DELETE_EXPENSE_SUCCESS, expenseId))
                }
                else {
                    alert(response.data.message)
                    dispatch(failure(EXPENSE_REQUEST.DELETE_EXPENSE_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(EXPENSE_REQUEST.DELETE_EXPENSE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
            }
        )
    }
}

export function addExpense(expenseData, closePopup) {
    return (dispatch) => {
        dispatch(request(EXPENSE_REQUEST.ADD_EXPENSE_REQUEST));
        addNewExpense(expenseData).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(EXPENSE_REQUEST.ADD_EXPENSE_SUCCESS, response.data.data))
                    if (closePopup) {
                        closePopup();
                    }
                    dispatch(getExpensesList());
                }
                else {
                    dispatch(failure(EXPENSE_REQUEST.ADD_EXPENSE_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(EXPENSE_REQUEST.ADD_EXPENSE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
            }
        )
    }
}

export function AddExpenseList(expenseData, closePopup) {
    return (dispatch) => {
        dispatch(request(EXPENSE_REQUEST.ADD_EXPENSE_REQUEST));
        // dispatch(request(EXPENSE_REQUEST.A))
        addNewExpenseList(expenseData).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(EXPENSE_REQUEST.ADD_EXPENSE_SUCCESS, response.data.data))
                    if (closePopup) {
                        closePopup();
                    }
                    dispatch(getExpensesList());
                }
                else {
                    dispatch(failure(EXPENSE_REQUEST.ADD_EXPENSE_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(EXPENSE_REQUEST.ADD_EXPENSE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
            }
        )
    }
}

export function getAllExpenseTypes() {
    return (dispatch) => {
        dispatch(request(EXPENSE_REQUEST.GET_EXPENSE_TYPE_REQUEST));
        getExpenseTypes().then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(EXPENSE_REQUEST.GET_EXPENSE_TYPE_SUCCESS, response.data.data))
                }
                else {
                    alert(response.data.message)
                    dispatch(failure(EXPENSE_REQUEST.GET_EXPENSE_TYPE_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(EXPENSE_REQUEST.GET_EXPENSE_TYPE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
            }
        )
    }
}

export function addExpenseType(expenseTypeData, close) {
    return (dispatch) => {
        dispatch(request(EXPENSE_REQUEST.ADD_EXPENSE_TYPE_REQUEST));
        addNewExpenseType(expenseTypeData).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(EXPENSE_REQUEST.ADD_EXPENSE_TYPE_SUCCESS, response.data.data))
                    if (close) {
                        close();
                    }
                }
                else {
                    dispatch(failure(EXPENSE_REQUEST.ADD_EXPENSE_TYPE_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(EXPENSE_REQUEST.ADD_EXPENSE_TYPE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
            }
        )
    }
}

export function removeExpenseType(expenseTypeId) {
    return (dispatch) => {
        dispatch(request(EXPENSE_REQUEST.DELETE_EXPENSE_TYPE_REQUEST));
        deleteExpenseType(expenseTypeId).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(EXPENSE_REQUEST.DELETE_EXPENSE_TYPE_SUCCESS, expenseTypeId))
                }
                else {
                    alert(response.data.message)
                    dispatch(failure(EXPENSE_REQUEST.DELETE_EXPENSE_TYPE_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(EXPENSE_REQUEST.DELETE_EXPENSE_TYPE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
            }
        )
    }
}

export function editExpenseType(expenseTypeData) {
    return (dispatch) => {
        dispatch(request(EXPENSE_REQUEST.EDIT_EXPENSE_TYPE_REQUEST));
        addNewExpenseType(expenseTypeData).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(EXPENSE_REQUEST.EDIT_EXPENSE_TYPE_SUCCESS, response.data.data))
                }
                else {
                    dispatch(failure(EXPENSE_REQUEST.EDIT_EXPENSE_TYPE_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(EXPENSE_REQUEST.EDIT_EXPENSE_TYPE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
            }
        )
    }
}

export function getAllSubExpenses() {
    return (dispatch) => {
        dispatch(request(EXPENSE_REQUEST.GET_SUBEXPENSE_REQUEST));
        getSubExpenseTypes().then((res) => {
            if (res.data.status === 1) {
                dispatch(success(EXPENSE_REQUEST.GET_SUBEXPENSE_SUCCESS, res.data.data));
            }
            else {
                dispatch(failure(EXPENSE_REQUEST.GET_SUBEXPENSE_FAILURE, res.data.message));
            }
        }, (error) => {
            dispatch(failure(EXPENSE_REQUEST.GET_SUBEXPENSE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        })
    }
}

export function addNewSubExpense(data, close) {
    return (dispatch) => {
        dispatch(request(EXPENSE_REQUEST.ADD_SUBEXPENSE_REQUEST));
        addSubExpenseType(data).then((res) => {
            if (res.data.status === 1) {
                dispatch(success(EXPENSE_REQUEST.ADD_SUBEXPENSE_SUCCESS, res.data.data));
                if (close) {
                    close();
                }
            }
            else {
                dispatch(failure(EXPENSE_REQUEST.ADD_SUBEXPENSE_FAILURE, res.data.message));
            }
        }, (error) => {
            dispatch(failure(EXPENSE_REQUEST.ADD_SUBEXPENSE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        })
    }
}

export function editSubExpense(data) {
    return (dispatch) => {
        dispatch(request(EXPENSE_REQUEST.EDIT_SUBEXPENSE_REQUEST));
        addSubExpenseType(data).then((res) => {
            if (res.data.status === 1) {
                dispatch(success(EXPENSE_REQUEST.EDIT_SUBEXPENSE_SUCCESS, res.data.data));
            }
            else {
                dispatch(failure(EXPENSE_REQUEST.EDIT_SUBEXPENSE_FAILURE, res.data.message));
            }
        }, (error) => {
            dispatch(failure(EXPENSE_REQUEST.EDIT_SUBEXPENSE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        })
    }
}

export function removeSubExpense(subexpenseId) {
    return (dispatch) => {
        dispatch(request(EXPENSE_REQUEST.DELETE_SUBEXPENSE_REQUEST));
        deleteSubExpenseType(subexpenseId).then((res) => {
            if (res.data.status === 1) {
                dispatch(success(EXPENSE_REQUEST.DELETE_SUBEXPENSE_SUCCESS, subexpenseId));
            }
            else {
                alert(res.data.message)
                dispatch(failure(EXPENSE_REQUEST.DELETE_SUBEXPENSE_FAILURE, res.data.message))
            }
        }, (error) => {
            dispatch(failure(EXPENSE_REQUEST.DELETE_SUBEXPENSE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        })
    }
}